import React from 'react';
import { useSelector } from 'dva';
import { Box } from '@material-ui/core';
import { useIntl } from 'umi';

import BaseInformationStyled from './BaseInformationStyled';

const BaseInformation = () => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  // const location = useLocation();
  // const { query } = location;
  //保持状态
  // const { tab } = query;
  // const { datas } = props;
  const datas = useSelector((state) => state.adjustDetail.memberDetail);
  const {
    name,
    mobile = '',
    level,
    memberCode,
    gender,
    // status,
  } = datas || {};
  const genderObj = {
    F: '女',
    M: '男',
    U: '未知',
  };
  return (
    <BaseInformationStyled>
      <Box className="box">
        <Box className="item">
          <div className="up">
            {formatMessage({ id: 'cm.member.detail.n01.lbl01' })}
          </div>
          <div className="down">{name}</div>
        </Box>
        <Box className="item">
          <div className="up">
            {formatMessage({ id: 'cm.member.detail.n01.lbl02' })}
          </div>
          <div className="down">{genderObj[gender]}</div>
        </Box>
        <Box className="item">
          <div className="up">
            {formatMessage({ id: 'cm.member.detail.n01.lbl03' })}
          </div>
          <div className="down">{memberCode}</div>
        </Box>
        <Box className="item">
          <div className="up">
            {formatMessage({ id: 'cm.member.detail.n01.lbl04' })}
          </div>
          <div className="down"> {mobile}</div>
        </Box>
        <Box className="item">
          <div className="up">
            {formatMessage({ id: 'cm.member.detail.n01.lbl05' })}
          </div>
          <div className="down"> {level}</div>
        </Box>
      </Box>
    </BaseInformationStyled>
  );
};
export default BaseInformation;
